<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row class="mx-0">
          <b-col cols="12">
            <!-- Master Account -->
            <validation-provider
              #default="validationContext"
              name="securos_master_account"
              rules="required"
            >
              <b-form-group
                :label="$tc('vxg_master_account.title', 1)"
                label-for="securos_master_account"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_securos_master_account"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="securosMasterAccountOptions"
                  :reduce="(val) => val.value"
                  input-id="securos_master_account"
                  :clearable="false"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Nombre -->
            <validation-provider
              #default="validationContext"
              name="name"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('vxg_camera.name')"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="itemData.name"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Nombre -->
            <validation-provider
              #default="validationContext"
              name="ip"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('vxg_camera.ip')"
                label-for="IP"
              >
                <b-form-input
                  id="IP"
                  v-model="itemData.ip"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mx-0" v-if="!isAdd">
          <b-col cols="6">
            <validation-provider #default="validationContext" name="model">
              <b-form-group
                class="text-capitalize"
                :label="$t('camera.model')"
                label-for="securos_model"
              >
                <b-form-input
                  id="securos_model"
                  v-model="itemData.model"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider #default="validationContext" name="login">
              <b-form-group
                class="text-capitalize"
                :label="$t('users.username')"
                label-for="securos_login"
              >
                <b-form-input
                  id="securos_login"
                  v-model="itemData.login"
                  :state="getValidationState(validationContext)"
                  trim
                  autocomplete="off"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider #default="validationContext" name="securos_password">
              <b-form-group
                class="text-capitalize"
                label="Password"
                label-for="securos_password"
              >
                <b-form-input
                  id="securos_password"
                  v-model="itemData.password"
                  :state="getValidationState(validationContext)"
                  type="password"
                  trim
                  autocomplete="new-password"
                  :placeholder="$t('camera.password_unchanged')"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mx-0">
          <b-col cols="6">
            <!-- Type -->
            <validation-provider
              #default="validationContext"
              name="Type"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('camera.type')"
                label-for="id_type"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_type"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="typeOptions"
                  :reduce="(option) => option.value"
                  :getOptionKey="(option) => option.value"
                  :clearable="false"
                  input-id="id_type"
                  data-cy="type_select"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Tags -->
            <validation-provider #default="validationContext" name="Tag">
              <b-form-group
                class="text-capitalize"
                label="Tag"
                label-for="id_device_tag"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_device_tag"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="deviceTagsOptions"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  input-id="id_device_tag"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="6">
            <validation-provider name="send_to_seproban" rules="required" vid="send_to_seproban">
              <b-form-checkbox
                id="send_to_seproban"
                v-model="itemData.send_to_seproban"
                name="send_to_seproban"
                value="1"
                class="my-1 text-capitalize"
                unchecked-value="0"
                switch
              >
                {{ $t("camera_proxy.send_to_seproban") }}
              </b-form-checkbox>
            </validation-provider>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import { ref, computed, onMounted, watch } from "@vue/composition-api";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

const isMacAddress = (str) => {
  // MAC address regex pattern (matches XX:XX:XX:XX:XX:XX or XX-XX-XX-XX-XX-XX format)
  const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
  return macRegex.test(str);
};

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
  },
  props: {
    securosMasterAccountOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    typeOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    isAdd: {
      type: Boolean,
      required: false,
      default: false,
    },
    propItemData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    propResData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    onMounted(() => store.dispatch('tenant/getDeviceTags'));

    const { t } = useI18nUtils();
    const { refFormObserver, getValidationState } = formValidation();
    const cameraTypeData = ref({
      password: props.propItemData?.cameraType?.password ?? '',
      user: props.propItemData?.cameraType?.user ?? '',
      url: props.propItemData?.cameraType?.url ?? '',
      http_port: props.propItemData?.cameraType?.http_port ?? '',
      rtps_port: props.propItemData?.cameraType?.rtps_port ?? '',
      path_onvif: props.propItemData?.cameraType?.path_onvif ?? '',
      mac_address: isMacAddress(props.propItemData?.cameraType?.serial_number) ? props.propItemData?.cameraType?.serial_number : '',
      serial_number: isMacAddress(props.propItemData?.cameraType?.serial_number) ? '' : props.propItemData?.cameraType?.serial_number
    });

    const itemData = ref({
      ...props.propItemData,
      password: cameraTypeData.value.password,
      username: cameraTypeData.value.user,
      url: cameraTypeData.value.url,
      http_port: cameraTypeData.value.http_port,
      rtps_port: cameraTypeData.value.rtps_port,
      path_onvif: cameraTypeData.value.path_onvif,
      mac_address: cameraTypeData.value.mac_address,
      serial_number: cameraTypeData.value.serial_number,
      uplink: false,
      type: cameraTypeData.value.type,
    });

    const resData = ref(props.propResData);
    const initialData = ref({ ...props.propItemData });

    const hasChanges = (key) => {
      return itemData.value[key] !== initialData.value[key];
    };

    const validateStep = () => {
      return refFormObserver.value.validate();
    };

    const setupWatcher = (itemData, key) => {
      watch(
        () => itemData.value[key],
        (newValue, oldValue) => {
          if (newValue !== oldValue && hasChanges(key)) {
            emit("update:itemData", { [key]: newValue });
          }
        }
      );
    };

    setupWatcher(itemData, "name");
    setupWatcher(itemData, "model");
    setupWatcher(itemData, "login");
    setupWatcher(itemData, "id_securos_master_account");
    setupWatcher(itemData, "password");
    setupWatcher(itemData, "stream_live");
    setupWatcher(itemData, "stream_recording");
    setupWatcher(itemData, "id_type");
    setupWatcher(itemData, "type");
    setupWatcher(itemData, "id_device_tag");
    setupWatcher(itemData, "ip");
    setupWatcher(itemData, "send_to_seproban");

    const deviceTagsOptions = computed(() => {
      const tags = store.getters["tenant/getDeviceTags"] || [];
      return tags.map((item) => ({
        label: item?.name || '',
        value: item?.id,
      }));
    });

    itemData.value.mac_address = itemData.value.mac_address;
    itemData.value.serial_number = itemData.value.serial_number;
    emit("update:itemData", { mac_address: itemData.value.mac_address });
    emit("update:itemData", { serial_number: itemData.value.serial_number });

    return {
      t,
      refFormObserver,
      getValidationState,
      validateStep,
      deviceTagsOptions,
      itemData,
      cameraTypeData,
    };
  },
};
</script>
